export type PATHS = keyof typeof routes

export const routes = {
    AUTH_ROUTES: {
        LOGIN: '/login',
        REGISTER: '/register',
        FORGOT_PASSWORD: "/forgot-password",
        EMAIL_SENT: "/email-sent",
        EMAIL_SENT_PASSWORD: "/check-email",
        GENERATE_PASSWORD: "/generate-password",
        LOGOUT: '/logout'
    },
    DASHBOARD_ROUTES: {
        DASHBOARD: '/',
        YARD: '/stable',
        HOME: '/dashboard',
        TRAININGS: '/trainings',
        COMPARAISON: '/compare-horse',
        ANALYTICS: '/analytics',
        DATA_SUCCESS: '/data-success',
        USER: '/user',
        PROFILE: '/user/profile',
        SETTINGS: '/user/settings',
        SHOEING: '/user/qualifications/horseShoeings',
        RIDERS: '/user/qualifications/riders',
        TRACKSCONDITIONS: '/user/qualifications/trackConditions',
        NOTIFICATIONS: '/user/notifications',
        TRACKS: '/user/qualifications/tracks',
        QUALIFICATION: '/user/qualifications',
        MYTRAININGS: '/user/myTrainings',
        MYANALYTICS: '/user/myAnalytics',
        TRAININGTYPE: '/user/qualifications/myTrainingTypes',
        TRACK_VIEW: '/user/qualifications/tracks/:id',
        BILLINGS: '/user/billings',
        ONBOARDING: '/user/onboarding',
        EQUIMETRES: '/user/equimetres',
        EXAM_VIEW: '/training/:id',
        HORSE_VIEW: '/horse/:id',
    },
    SETTINGS_ROUTES: {
        PDF: '/settings/notification',
    },
    PDF_ROUTES: {
        COMPARAISON: '/pdf/comparaison',
        TRAINING: '/pdf/training/:id',

        /* Auto wa send */
        GALLOP: '/pdf/gallop-review',
        STABLE: '/pdf/stable-review',
        TRAININGS:'/pdf/trainings-review'
    },
    OTHER_ROUTES: {
        UNSUBSCRIBE: '/unsubscribe',
        MANTAINANCE: '/maintenance'
    },
    PUBLIC_ROUTES:{
        legalNotice:'/public/legal-notice',
        dataProtection:'/public/data-protection',
    }


} as const